import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { MonedaDirective } from '@directives/moneda.directive';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoRegistroContableService } from '@services/tipoRegistroContable/tipoRegistroContable.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';

@Component({
  standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, MonedaDirective, SelectUsuariosEmpresaComponent, NgxMaskDirective],
  selector: 'app-dialog-tipo-registro-contable-generic',
  templateUrl: './dialog-tipo-registro-contable-generic.component.html',
  styleUrls: ['./dialog-tipo-registro-contable-generic.component.css']
})
export class DialogTipoRegistroContableGenericComponent {


  local_data: any;
  form: any;
  formBuilder: FormBuilder = new FormBuilder;
  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogTipoRegistroContableGenericComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private tipoRegistroContableService: TipoRegistroContableService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {
    this.local_data = { ...data };

    this.form = this.formBuilder.group({
      Descripcion: ['', Validators.compose([Validators.required, Validators.maxLength(200)])],
    })

    if (this.local_data.action == AccionesDialog.Eliminar) {
      this.form.controls["Descripcion"].setValue(this.local_data.descripcion)
    }
  }

  ngOnInit(): void {
    if (this.local_data.action == AccionesDialog.Modificar || this.local_data.action == AccionesDialog.Ver)
      this.completaFormulario()
  }
  completaFormulario() {
    this.form.controls['Descripcion'].value = this.local_data.descripcion
    this.form.controls['TipoRegistroContable'].value = this.local_data.tipoRegistroContable.id
    this.form.controls['Importe'].value = this.local_data.importe
    this.form.controls['FechaRegistroContable'].value = this.local_data.fechaRegistroContable
    if (this.local_data.importe < 0)
      this.form.controls['EgresoIngreso'].value = "-1"
  }
  doAction() {
    switch (this.local_data.action) {
      case AccionesDialog.Agregar:
        this.create()
        break;
      case AccionesDialog.Modificar:
        this.update()
        break;
      case AccionesDialog.Eliminar:
        this.delete()
        break;
      default:
        break;
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }


  create() {
    if (this.form.invalid) {
      return;
    }
    const createKeyValueRequest: CreateKeyValueRequest = new CreateKeyValueRequest
    createKeyValueRequest.descripcion = isFalsy(this.form.controls['Descripcion'].value) ? null : this.form.controls['Descripcion'].value;
    this.spinner.show("spLoadGeneric")

    this.tipoRegistroContableService.create(createKeyValueRequest)
      .subscribe(
        data => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showSuccess("Se agrego el registro correctamente.", "Exito");
          this.dialogRef.close({ data: this.local_data });
        },
        error => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showError(error, "Error");
        })
  }

  update() {
    if (this.form.invalid) {
      return;
    }
    const updateKeyValueRequest: UpdateKeyValueRequest = new UpdateKeyValueRequest
    updateKeyValueRequest.id = this.local_data.id
    updateKeyValueRequest.descripcion = isFalsy(this.form.controls['Descripcion'].value) ? null : this.form.controls['Descripcion'].value;

    this.spinner.show("spLoadGeneric")

    this.tipoRegistroContableService.update(updateKeyValueRequest)
      .subscribe(
        data => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showSuccess("Se modifico el registro correctamente.", "Exito");
          this.dialogRef.close({ data: this.local_data });
        },
        error => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showError(error, "Error");
        })
  }

  delete() {
    if (this.form.invalid) {
      return;
    }
    this.spinner.show("spLoadGeneric")
    this.tipoRegistroContableService.delete(this.local_data.id)
      .subscribe(
        data => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showSuccess("Se elimino el registro correctamente.", "");
          this.dialogRef.close({ data: this.local_data });
        },
        error => {
          this.spinner.hide("spLoadGeneric")
          this.snackBar.showError(error, "Error");
        })
  }
}
